<template>
  <div class="style-tab-text-style">
    <ul class="editor-design">
      <li>
        テキスト
      </li>
      <li class="flex-box end">
        <!-- フォント -->
        <select-box
          :target="'font-family-name'"
          :value="value['font-family-name']"
          @updateStyles="updateStyles($event)"
        />
        <!-- 書体 -->
        <select-style
          :fontWeight="value['font-weight']"
          :fontStyle="value['font-style']"
          @updateStyles="updateStyles($event)"
        />
        <!-- 揃え位置 -->
        <select-button
          v-if="showSettingAlign"
          :target="'text-align'"
          :value="value['text-align']"
          @updateStyles="updateStyles($event)"
        />
      </li>
      <li class="flex-box last">
        <!-- フォントサイズ -->
        <select-box
          :target="'font-size'"
          :value="value['font-size']"
          @updateStyles="updateStyles($event)"
        />
        <!-- 行の高さ -->
        <select-box
          v-if="showSettingLineHeight"
          :target="'line-height'"
          :value="value['line-height']"
          @updateStyles="updateStyles($event)"
        />
        <!-- 文字色 -->
        <select-color
          :type="'part'"
          :target="'color'"
          :selector="null"
          :value="value['color']"
          @updateStyles="updateStyles($event)"
          id="text-style-color"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import SelectBox from '@/components/Content/Palette/CommonLayouts/EditStyleSelectBox'
import SelectButton from '@/components/Content/Palette/CommonLayouts/EditStyleSelectButton'
import SelectColor from '@/components/Content/Palette/CommonLayouts/EditStyleSelectColor'
import SelectStyle from '@/components/Content/Palette/CommonLayouts/EditStyleWeightAndItalic'

export default {
  props: [
    'value',
    'sectionId',
    'partsContainerId',
    'partId',
    'partsContainerType',
  ],
  components: {
    SelectBox,
    SelectButton,
    SelectColor,
    SelectStyle,
  },
  computed: {
    showSettingAlign () {
      const partsContainer = this.$store.getters.findPartsContainer(this.sectionId, this.partsContainerId)
      if (!partsContainer) return null
      return (partsContainer.type !== 'FollowButton') && (partsContainer.type !== 'Share')
    },
    showSettingLineHeight () {
      const partsContainer = this.$store.getters.findPartsContainer(this.sectionId, this.partsContainerId)
      if (!partsContainer) return null
      return (partsContainer.type !== 'FollowButton') && (partsContainer.type !== 'Share')
    },
  },
  methods: {
    updateStyles (styles) {
      this.$store.commit('updatePartStyles', {
        sectionId: this.sectionId,
        partsContainerId: this.partsContainerId,
        partId: this.partId,
        styles: styles
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.flex-box {
  &.last {
    margin-bottom: 0;
    padding-bottom: 10px;
  }
  &.end {
    align-items: flex-end;
  }
}
</style>

<style lang="scss">
#text-style-color {
  .window {
    right: 0;
  }
}
</style>
